module.exports = "<input class=\"input input_number js-input\" type=\"text\" {{#if fieldId}} id=\"{{fieldId}} {{/if}}\">";